/**
 * Categorical palette for shifts within a day. Class strings are written out
 * in full so Tailwind can see them.
 */
const SHIFT_TONES = [
  { dot: 'bg-[#9b6dff]', chip: 'bg-[#9b6dff]/12 ring-[#9b6dff]/30', panel: 'border-l-[#9b6dff]' },
  { dot: 'bg-[#5aa9ff]', chip: 'bg-[#5aa9ff]/12 ring-[#5aa9ff]/30', panel: 'border-l-[#5aa9ff]' },
  { dot: 'bg-[#3ecf8e]', chip: 'bg-[#3ecf8e]/12 ring-[#3ecf8e]/30', panel: 'border-l-[#3ecf8e]' },
  { dot: 'bg-[#f5b544]', chip: 'bg-[#f5b544]/12 ring-[#f5b544]/30', panel: 'border-l-[#f5b544]' },
  { dot: 'bg-[#f26d9b]', chip: 'bg-[#f26d9b]/12 ring-[#f26d9b]/30', panel: 'border-l-[#f26d9b]' },
] as const;

export type ShiftTone = (typeof SHIFT_TONES)[number];

export const getShiftTone = (index: number): ShiftTone => SHIFT_TONES[index % SHIFT_TONES.length];
